import React, { memo, FC } from 'react';

import Svg from './Svg';
import colors from '../../utils/colorConstants';

interface Props {
  className?: string;
  height: string;
  strokeColor?: string;
  width: string;
}

const Tracking: FC<Props> = ({
  className,
  height = '1.5rem',
  strokeColor = colors.lapel,
  width = '1.5rem',
}) => (
  <Svg
    className={className}
    height={height}
    title="tracking icon"
    viewBox="0 0 24 24"
    width={width}
  >
    <path
      d="M6 12.89c.8 0 1.57.2 2.25.6a.5.5 0 01-.5.86 3.5 3.5 0 101.69 2.36.5.5 0 11.98-.2A4.52 4.52 0 016 21.9a4.5 4.5 0 110-9zm5.34-.26a.5.5 0 01.08.63l-.05.08-4.91 5.38a.5.5 0 01-.71.03l-.06-.06-1.1-1.47a.5.5 0 01.75-.66l.06.07.73.97 4.5-4.94a.5.5 0 01.7-.03zm10.28 4.76a.5.5 0 01.09.99h-9.33a.5.5 0 01-.09-.98l.1-.01h9.23zM6 2.5c.8 0 1.57.2 2.25.6a.5.5 0 01-.5.87 3.5 3.5 0 101.69 2.36.5.5 0 01.98-.2A4.52 4.52 0 016 11.5a4.5 4.5 0 010-9zm5.34-.26a.5.5 0 01.08.64l-.05.07-4.91 5.39a.5.5 0 01-.71.03l-.06-.07-1.1-1.46a.5.5 0 01.75-.67l.06.07.73.97 4.5-4.93a.5.5 0 01.7-.04zM21.62 7a.5.5 0 01.09 1h-9.33a.5.5 0 01-.09-1h9.33z"
      fill={strokeColor}
    />
  </Svg>
);

export default memo(Tracking);
